import * as CryptoJS from 'crypto-js';
import { FB_MTPD } from 'presentation/events/constants/eventConstants';

const META_USER_TYPE = {
	GUEST: 'G',
	REGISTERED: 'R',
} as const;

type SaveFacebookCAPIUserAttributesParams = {
	email: string | null | undefined;
	phone: string | null | undefined;
	isGuest: boolean;
};

type ClearGuestFacebookCAPIAttributesParams = {
	pathname: string;
};

/**
 * Persists the hashed Facebook CAPI user identifiers (MTPD) in localStorage
 * so GTM can read them across page loads.
 */
export const saveFacebookCAPIUserAttributes = ({
	email,
	phone,
	isGuest,
}: SaveFacebookCAPIUserAttributesParams) => {
	try {
		const hasEmail = email !== null && email !== undefined;
		const hasPhone = phone !== null && phone !== undefined;
		const metaAttr = {
			MTPE: hasEmail ? sha256value(email) : null,
			MTPPM: hasPhone ? sha256value('52' + phone) : null,
			MTPPT: hasPhone ? sha256value('+52' + phone) : null,
			type: isGuest ? META_USER_TYPE.GUEST : META_USER_TYPE.REGISTERED,
		};
		localStorage.setItem(FB_MTPD, JSON.stringify(metaAttr));
	} catch (e) {
		console.log(`Error creating MTPD`);
	}
};

/**
 * Removes the guest MTPD entry on navigation away from checkout/thank-you pages.
 * Registered users (type === 'R') keep their entry.
 */
export const clearGuestFacebookCAPIAttributes = ({
	pathname,
}: ClearGuestFacebookCAPIAttributesParams) => {
	if (!pathname.includes('checkout') && !pathname.includes('thank-you')) {
		try {
			const MTP = JSON.parse(localStorage.getItem(FB_MTPD) || '{}');
			if (MTP.type !== META_USER_TYPE.REGISTERED) {
				localStorage.removeItem(FB_MTPD);
			}
		} catch (e) {
			console.log(e);
		}
	}
};

/**
 * Removes the MTPD entry after a short delay so any in-flight pixel reads
 * still have access to the value.
 */
export const clearFacebookCAPIAttributes = () => {
	try {
		setTimeout(async () => {
			localStorage.removeItem(FB_MTPD);
		}, 2000);
	} catch (e) {
		console.log(`Error removing MTPD`);
	}
};

const sha256value = (crypoValue: string) => CryptoJS.SHA256(crypoValue).toString(CryptoJS.enc.Hex);
